import { fetchProviderFilterMetadataWithCount, FilterMetadataApiWithCountReturn } from "../misc";
import { useCallback } from "react";
import { useAsync } from "../hooks";

export const useProvidersMetadataWithCount = ({
    // metadataWithCount,
    setMetadataLoading,
    setMetadataWithCount
}: {
    metadataWithCount?: FilterMetadataApiWithCountReturn;
    setMetadataLoading?: React.Dispatch<React.SetStateAction<boolean>>;
    setMetadataWithCount?: React.Dispatch<React.SetStateAction<FilterMetadataApiWithCountReturn>>;
}) => {
    const load = useCallback(
        async (signal?: AbortSignal): Promise<FilterMetadataApiWithCountReturn> => {
            // if (metadataWithCount) return;

            setMetadataLoading && setMetadataLoading(true);
            const _metadataWithCount = await fetchProviderFilterMetadataWithCount({
                signal
            });
            return _metadataWithCount;
        },
        [setMetadataLoading]
    );

    const onLoad = useCallback(
        (metadataWithCount: FilterMetadataApiWithCountReturn) => {
            if (metadataWithCount === undefined) return;

            setMetadataWithCount && setMetadataWithCount(metadataWithCount);
            setMetadataLoading && setMetadataLoading(false);
        },
        [setMetadataLoading, setMetadataWithCount]
    );

    // useEffect(() => {
    //     // load search params
    //     const load = async () => {
    //         if (metadataWithCount) return;

    //         const _metadataWithCount = await fetchProviderFilterMetadataWithCount();

    //         setMetadataLoading && setMetadataLoading(true);
    //         setMetadataWithCount && setMetadataWithCount(_metadataWithCount);
    //         setMetadataLoading && setMetadataLoading(false);
    //     };

    //     load();
    // }, [metadataWithCount, setMetadataLoading, setMetadataWithCount]);

    useAsync(load, onLoad);
};
